var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"crly-a-common-search-category-small icon",class:`cd-${_vm.category.catSmlCd}`,on:{"click":_vm.clickSmallCat}},[_c('div',{staticClass:"crly-a-common-search-category-small__label"},[_vm._v(" "+_vm._s(_vm.category.catSmNm)+" ")]),_c('div',{staticClass:"crly-a-common-search-category-small__icon crly-link-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }